// Keep crop IDs and the 24-bed expansion order stable across saved games.
export const FARM_ORIGIN = Object.freeze({ x: -1.7, y: 2.05, z: -7.2 });
const offsets = [[-1.35, -1.35], [1.35, -1.35], [-1.35, 1.35], [1.35, 1.35]];
// Expand away from the foreground palm and the cottage entrance.
for (const dz of [-2.7, 2.7, -1.35, 1.35]) for (const dx of [-4.05, -2.7, 1.35, 2.7, -1.35, -5.4]) {
  if (!offsets.some(([x, z]) => x === dx && z === dz)) offsets.push([dx, dz]);
}
export const FARM_BED_OFFSETS = Object.freeze(offsets.map(row => Object.freeze(row)));
export const FARM_BED_CENTRES = Object.freeze(offsets.map(([dx, dz]) => Object.freeze([FARM_ORIGIN.x + dx, FARM_ORIGIN.z + dz])));
